import React, { useState, useEffect, useCallback } from "react";
import {
  Label,
  Input,
  FormFeedback,
  Form,
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
// Eğer Redux dispatch'i burada kullanılmıyorsa kaldırılabilir
// import { useDispatch } from "react-redux";
import axios from "axios";

// Yeni prop'lar: isNewPoll ve onOptionsChange (callback için)
const PollOptionsManager = ({ pollId, initialOptions, onOptionActionSuccess, isNewPoll = false, onOptionsChange }) => {
  // Eğer Redux aksiyonlarını dispatch etmiyorsanız bu satırı kaldırabilirsiniz.
  // const dispatch = useDispatch(); 
  const [options, setOptions] = useState(initialOptions || []);
  const [editingOption, setEditingOption] = useState(null);

  // initialOptions prop'u değiştiğinde seçenekleri günceller
  // Bu useEffect, dışarıdan gelen initialOptions değiştiğinde (örn: düzenleme moduna geçişte) çalışır.
  useEffect(() => {
    setOptions(initialOptions || []);
  }, [initialOptions]);

  // Seçenekler (options state'i) her değiştiğinde ve yeni anket modundaysak, parent'a bildir.
  // Bu, ContactsList'teki newPollOptions state'ini güncel tutar.
  useEffect(() => {
    if (isNewPoll && onOptionsChange) {
      onOptionsChange(options);
    }
  }, [options, isNewPoll, onOptionsChange]); // 'options' bağımlılığına dikkat!

  const validation = useFormik({
    enableReinitialize: true, // initialValues'ın değiştiğinde formu yeniden başlatmasını sağlar
    initialValues: {
      optionTitle: (editingOption && editingOption.Poll_Option_Title) || "",
    },
    validationSchema: Yup.object({
      optionTitle: Yup.string().required("Seçenek Başlığı gerekli"),
    }),
    onSubmit: async (values) => {
      if (editingOption) {
        // Seçenek güncelleme işlemi
        if (isNewPoll) {
          // Yeni anket modundaysa, sadece yerel state'i güncelle (API'ye gönderme)
          const updatedLocalOptions = options.map(opt =>
            opt.ID === editingOption.ID ? { ...opt, Poll_Option_Title: values.optionTitle } : opt
          );
          setOptions(updatedLocalOptions); // useEffect aracılığıyla parent'a bildirilir
          setEditingOption(null); // Düzenleme modunu kapat
          validation.resetForm(); // Formu sıfırla
        } else {
          // Mevcut anket modundaysa, API ile güncelle
          const updatedOptionPayload = {
            Poll_Option_Title: values.optionTitle,
          };

          try {
            const res = await axios.patch(`https://adminoy.oyliyo.com.tr:9654/updatePollOptions/${editingOption.ID}`, updatedOptionPayload);
            console.log("Seçenek güncellendi:", res.data);
            const updatedOption = { // UI'ı güncellemek için tam nesneyi oluştur
              ...editingOption,
              Poll_Option_Title: values.optionTitle,
            };
            setOptions(options.map(opt => (opt.ID === updatedOption.ID ? updatedOption : opt))); // UI'ı hemen güncelle
            if (onOptionActionSuccess) onOptionActionSuccess(); // Parent'ı bilgilendir (anket listesini yenile vs.)
            setEditingOption(null); // Düzenleme modunu kapat
            validation.resetForm(); // Formu sıfırla
          } catch (error) {
            console.error("Seçenek güncellenirken hata oluştu:", error);
            // Kullanıcıya hata mesajı gösterebilirsiniz
          }
        }
      } else {
        // Yeni seçenek ekleme işlemi
        if (isNewPoll) {
          // Yeni anket modundaysa, sadece yerel state'e ekle (geçici ID ile)
          const newLocalOption = {
            ID: Date.now(), // Geçici benzersiz ID (sadece frontend tarafında liste yönetimi için)
            Poll_Option_Title: values.optionTitle,
            Poll_ID: null, // Yeni anket için şimdilik null
          };
          setOptions([...options, newLocalOption]); // useEffect aracılığıyla parent'a bildirilir
          validation.resetForm(); // Formu sıfırla
        } else {
          // Mevcut anket modundaysa, API ile ekle
          const newOptionPayload = {
            Poll_Option_Title: values.optionTitle,
            Poll_ID: pollId,
          };

          try {
            const res = await axios.post('https://adminoy.oyliyo.com.tr:9654/addPollOptions/send', newOptionPayload);
            console.log("Yeni seçenek eklendi:", res.data);
            const newOption = {
              ID: res.data.value[0].ID, // Backend'den gelen gerçek ID'yi kullan
              Poll_Option_Title: values.optionTitle,
              Poll_ID: pollId,
            };
            setOptions([...options, newOption]); // UI'ı hemen güncelle
            if (onOptionActionSuccess) onOptionActionSuccess(); // Parent'ı bilgilendir
            validation.resetForm(); // Formu sıfırla
          } catch (error) {
            console.error("Yeni seçenek eklenirken hata oluştu:", error);
            // Kullanıcıya hata mesajı gösterebilirsiniz
          }
        }
      }
    },
  });

  const handleEditOption = (option) => {
    setEditingOption(option);
    validation.setFieldValue("optionTitle", option.Poll_Option_Title);
  };

  const handleDeleteOption = async (optionId) => {
    if (isNewPoll) {
      // Yeni anket modundaysa, sadece yerel state'ten sil
      setOptions(options.filter(opt => opt.ID !== optionId)); // useEffect aracılığıyla parent'a bildirilir
    } else {
      // Mevcut anket modundaysa, API ile sil
      try {
        const res = await axios.delete(`https://adminoy.oyliyo.com.tr:9654/deletePollOptions/${optionId}`);
        console.log("Seçenek silindi, ID:", optionId, res.data);
        setOptions(options.filter(opt => opt.ID !== optionId)); // UI'ı hemen güncelle
        if (onOptionActionSuccess) onOptionActionSuccess(); // Parent'ı bilgilendir
      } catch (error) {
        console.error("Seçenek silinirken hata oluştu:", error);
        // Kullanıcıya hata mesajı gösterebilirsiniz
      }
    }
  };

  const handleCancelEdit = () => {
    setEditingOption(null);
    validation.resetForm(); // İptal edildiğinde formu temizle
  };

  return (
    <div>
      <Form
        onSubmit={(e) => {
          e.preventDefault(); // Varsayılan form gönderimini engelle
          validation.handleSubmit(); // Formik'in gönderim işleyicisini çağır
        }}
      >
        <Row>
          <Col xs={9}>
            <div className="mb-3">
              <Label className="form-label">Seçenek Başlığı</Label>
              <Input
                name="optionTitle"
                type="text"
                placeholder="Seçenek Başlığını Giriniz"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.optionTitle || ""}
                invalid={
                  validation.touched.optionTitle && validation.errors.optionTitle
                    ? true
                    : false
                }
              />
              {validation.touched.optionTitle && validation.errors.optionTitle ? (
                <FormFeedback type="invalid">
                  {validation.errors.optionTitle}
                </FormFeedback>
              ) : null}
            </div>
          </Col>
          <Col xs={3} className="d-flex align-items-end">
            <Button
              type="submit" // Bu düğme formun submit düğmesidir
              color="primary"
              className="mb-3"
              // onClick işleyicisi eklenerek varsayılan HTML submit davranışı engellendi
              onClick={(e) => {
                e.preventDefault(); // Tarayıcının varsayılan submit davranışını durdur
                validation.handleSubmit(); // Formik'in kendi submit fonksiyonunu çağır
              }}
            >
              {editingOption ? "Güncelle" : "Ekle"}
            </Button>
            {editingOption && (
              <Button
                type="button" // Bu bir submit düğmesi değil, iptal düğmesi
                color="secondary"
                className="mb-3 ms-2"
                onClick={handleCancelEdit}
              >
                İptal
              </Button>
            )}
          </Col>
        </Row>
      </Form>

      <h5 className="mt-4">Mevcut Seçenekler</h5>
      {options.length > 0 ? (
        <ListGroup className="mt-3">
          {options.map((option) => (
            <ListGroupItem key={option.ID} className="d-flex justify-content-between align-items-center">
              {option.Poll_Option_Title}
              <div>
                <Button color="info" size="sm" className="me-2" onClick={() => handleEditOption(option)}>
                  <i className="mdi mdi-pencil" />
                </Button>
                <Button color="danger" size="sm" onClick={() => handleDeleteOption(option.ID)}>
                  <i className="mdi mdi-delete" />
                </Button>
              </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      ) : (
        <p>Bu ankete ait seçenek bulunmamaktadır.</p>
      )}
    </div>
  );
};

export default PollOptionsManager;